@let definition =
  definitionsEc.plugins.currentEntityPlugin.feature.selectors
    .getEditedEntity()
    .asSignal();
@if (definition) {
  @let isCreating =
    definitionsEc.plugins.currentEntityPlugin.feature.selectors
      .isCreating()
      .asSignal();
  @let isSubmitting =
    definitionsEc.plugins.editingPlugin.feature.selectors.isSubmitting.asSignal();
  @let submissionError =
    definitionsEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  @let persistedDefinition =
    definitionsEc.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asSignal();

  <atn-ds-centered-overlay type="wide">
    <atn-ds-widget
      class="atn-integration-definition-modal"
      [title]="
        isCreating ? 'Create connector definition' : 'Edit connector definition'
      "
    >
      <i
        actions
        class="atn-icon atn-close atn-red"
        (click)="cancel()"
      ></i>
      <div class="atn-integration-definition-modal__content">
        @if (!isCreating && persistedDefinition) {
          <div class="atn-integration-definition-modal__id">
            <b>ID</b>
            <atn-ds-value [value]="persistedDefinition.id" />
          </div>
        }
        <atn-ds-text
          label="Name"
          placeholder="Jira Epics"
          [value]="definition.name"
          (change)="nameChangeHandler($event ?? '')"
        />
        <atn-ds-code
          label="Definition JSON"
          syntax="json"
          [json]="{ imports: definition.imports ?? [] }"
          (jsonChange)="definitionChangeHandler($event)"
        />
        <atn-admin-error-message [message]="submissionError" />
      </div>
      <div
        class="atn-integration-definition-modal__footer"
        footer
      >
        <atn-ds-button
          type="transparent"
          (click)="cancel()"
        >
          Cancel
        </atn-ds-button>
        <atn-ds-button
          [disabled]="isSubmitting || !definition.name"
          (click)="save()"
        >
          Save
        </atn-ds-button>
      </div>
    </atn-ds-widget>
  </atn-ds-centered-overlay>
}
